import { Component, OnInit,Input } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Product } from '../../entities/product.entities'
import { ProductService } from '../../services/product.service'

@Component({
  selector: 'app-dried-food',
  templateUrl: './dried-food.component.html',
  styleUrls: ['./dried-food.component.css']
})
export class DriedFoodComponent implements OnInit {

  @Input('data') meals: string[] = [];
  page: number = 1;

  private products: Product[] = [];
  constructor(private productService: ProductService,private titleService: Title) { }

  ngOnInit() {
    
    this.titleService.setTitle("อาหารอบแห้ง");
    this.productService.getProduct().subscribe((snapshot) => {
      let index: number = 0;
      for (var i = 0; i < snapshot.length; i++) {
        if (snapshot[i].type == '3') {
          this.products[index] = snapshot[i]
          index++;
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/dried-food/dried-food.component.ts